<template>
    <div v-if="listCourt" :class="cssClass">
        <b-form-row>
            <b-form-group :label="$t('Vue.ListCourtDetails.Label.ListCourt')"
                          label-for="listCourtDisplayName"
                          class="col-md-6">
                <b-form-input name="listCourtDisplayName"
                              :value="listCourt.displayName"
                              readonly>
                </b-form-input>
            </b-form-group>
        </b-form-row>
        <b-form-row>
            <b-form-group label="Court/Tribunal/Other"
                          label-for="courtRegistry"
                          class="col-md-4">
                <b-form-input name="courtRegistry"
                              :value="listCourt.courtRegistryName"
                              readonly>
                </b-form-input>
            </b-form-group>
            <b-form-group label="Jurisdiction"
                          label-for="courtJurisdiction"
                          class="col-md-4">
                <b-form-input name="courtJurisdiction"
                              :value="listCourt.courtJurisdictionName"
                              readonly>
                </b-form-input>
            </b-form-group>
        </b-form-row>
        <b-form-row>
            <b-form-group label="Presiding Officer/s"
                          label-for="courtJudges"
                          class="col-md-12">
                <select2 name="courtJudges"
                         disabled
                         multiple
                         :options="listCourt.assignedJudgeDisplayNames"
                         :value="listCourt.assignedJudgeDisplayNames"></select2>
            </b-form-group>
        </b-form-row>
        <b-row>
            <b-form-group label="Description"
                          label-for="description"
                          class="col-md-12">
                <b-form-textarea name="description"
                                 readonly
                                 :value="listCourt.description"></b-form-textarea>
            </b-form-group>
        </b-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import Select2 from './Select2';

    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);

    export default {
        name: 'ListCourtDetails',
        mixins: [ErrorsMixin],
        props: {
            apiUrl: {
                type: String,
                required: true
            },
            listCourtId: {
                type: String,
                default: null
            },
            cssClass: {
                type: String,
                default: null
            },
            showFullDetails: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            listCourtId: function () {
                this.reload();
            }
        },
        data: function () {
            return {
                listCourt: null
            };
        },
        methods: {
            reload: function () {
                if (this.listCourtId) {
                    var url = this.apiUrl;
                    if (!url.endsWith('/')) url += '/';
                    url += 'listcourt/' + this.listCourtId;
                    return axios //we return the Promise that is created by the axios request 
                        .get(url)
                        .then(response => {
                            this.listCourt = response.data;
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                }
                return Promise.resolve(); //this produces an immediately resolved promise, this will ensure that we always return a Promise
            }
        },
        mounted: function () {
            this.reload();
        }
    }
</script>